export default __webpack_public_path__ + "static/icon-dropdown-case-studies-c251f1dba65855ddf128c8a52c73903b.svg";